module.exports = __webpack_public_path__ + "static/img/michael-amadeus-oidJ1WGkIeY-unsplash_thumb.d368654.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/michael-amadeus-oidJ1WGkIeY-unsplash_thumb.png
// module id = YwWO
// module chunks = 4